import { pretty } from '@/utils/text'

export default {
  filters: {
    pretty: pretty
  }
}
